import React, { Component } from 'react';
import '../index.scss';

import biglogo from '../assets/img/common/Logo_Noel.svg';
import bonhomme from '../assets/img/common/bonhomme.svg';
import instgramlogo from '../assets/img/common/logo_instagram.svg';
import twitterlogo from '../assets/img/common/logo_twitter.svg';
import discordlogo from '../assets/img/common/logo_discord.svg';
import GoogleAd from './GoogleAd';

class HomePage extends Component {
    render() {
        return (
            <div className='center'>
                <div className='snows' id="snows"></div>
                <GoogleAd slot="5523609982" />
                <img src={biglogo} alt="InfoGare" id='logo' className='logo' />
                <h1>Bienvenue sur InfoGare !</h1>
                <h3><code>Créer des infogares deviens facile</code></h3>
                <div style={{ height: '150px', padding: '1px', backgroundColor: 'red', borderRadius: '5px' }}>
                    <h2 style={{ color: 'white' }}>ATTENTION !</h2>
                    <span style={{ color: 'white' }}>Cette version est remplacée par la V3.1 et est vouée à disparaitre d'ici peut!</span><br /><br />
                    <a style={{ fontWeight: 'bold'}} href="https://absolument-oui.github.io/posts/InfoGare/V3.1-2.html" target="_blank" style={{ color: 'white' }}>Lire cet article</a>
                </div>
                <GoogleAd slot="5523609982" />
                <h2>Qu'est-ce qu'InfoGare ?</h2>
                <span>InfoGare est un site Internet qui vous permet de reproduire les écrans présents en gares SNCF en personnalisant les informations. Diverse options sont disponibles tel que la composition des trains, les gares desservies, les informations dynamiques et bien d'autres.</span><br />
                <small>ATTENTION : les informations sur les trains et gares que vous trouverez ici sont fictives !</small>
                <h2>Comment utiliser InfoGare ?</h2>
                <span>Il suffit tout simplement de vous créer un compte et vous pourrez ensuite créer des gares et trains. Vous disposez d'un guide complet <b><a href="https://docs.infogare.fr/InfoGare" target="_blank">ici</a></b> !</span>
                <h2>J'aimerais suivre les actualités du projet !</h2>
                <span>Voici les endroits où vous pouvez suivre le projet :</span><br /><br />
                <table>
                    <tbody>
                        <tr>
                            <td><img src={instgramlogo} height='32' alt='Instgaram' /></td>
                            <td><a href="https://link.infogare.fr/Instagram" target="_blank">@absolument_oui_dev</a></td>
                            <td>&nbsp;</td>
                            <td><img src={twitterlogo} height='32' alt='Twitter' /></td>
                            <td><a href="https://link.infogare.fr/Twitter" target="_blank">@AbsolumentOuiDe</a></td>
                            <td>&nbsp;</td>
                            <td><img src={discordlogo} height='32' alt='Discord' /></td>
                            <td><a href="https://link.infogare.fr/Discord" target="_blank">Serveur InfoGare</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    componentDidMount() {
        for (var i = 0; i < 100; i++) {
            var snow = document.createElement('div');
            snow.className = 'snowflake';
            document.getElementById('snows').appendChild(snow);
        }
        var logomode = 0;

        var logo = document.getElementById('logo');
        logo.onclick = function () {
            if (logomode == 0) {
                logo.src = bonhomme;
                logomode = 1;
            } else {
                logo.src = biglogo;
                logomode = 0;
            }
        };
    }
}

export default HomePage;